import { RSAA } from "redux-api-middleware";
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from "../../config/ApiConstants";

export function editAccount_API_Action(token, data) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/me/profile`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
      types: [
        types.EDIT_ACCOUNT_DETAILS_REQUEST,
        types.EDIT_ACCOUNT_DETAILS_RECEIVE,
        {
          type: types.EDIT_ACCOUNT_DETAILS_FAILURE,
          meta: (action, state, res) => {
            return action, state, res;
          },
        },
      ],
    },
  };
}

export const reset_editAccount_API_Action = () => {
  return {
    type: types.RESET_EDIT_ACCOUNT_DETAILS,
    payload: null,
  };
};

export function changePassword_API_Action(token, data) {
  // console.log("data:::: ", data);
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/me/change-password`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
      types: [
        types.CHANGE_PASSWORD_REQUEST,
        types.CHANGE_PASSWORD_RECEIVE,
        {
          type: types.CHANGE_PASSWORD_FAILURE,
          meta: (action, state, res) => {
            return action, state, res;
          },
        },
      ],
    },
  };
}

export const reset_changePassword_API_Action = () => {
  return {
    type: types.RESET_CHANGE_PASSWORD,
    payload: null,
  };
};

export function deleteAccount_API_Action(token) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/me/delete`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: "Bearer " + token,
      },
      body: "",
      types: [
        types.DELETE_ACCOUNT_REQUEST,
        types.DELETE_ACCOUNT_RECEIVE,
        {
          type: types.DELETE_ACCOUNT_FAILURE,
          meta: (action, state, res) => {
            return action, state, res;
          },
        },
      ],
    },
  };
}

export const reset_deleteAccount_API_Action = () => {
  return {
    type: types.RESET_DELETE_ACCOUNT,
    payload: null,
  };
};
